<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/custom/config/craft/send/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('shebeimingchen')">
            <el-input v-model="yt.conditions.equipmentName"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear()">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button
          size="mini"
          v-if="utils.checkPower('web_process_distribution_config_craft_send_batchInsert')"
          @click="
            yt.showEditDialog('xinzeng', null, 'w1');
            setDefaultValue();
            getProcedureCode();
          "
          type="primary"
        >
          {{ $t('xinzeng') }}
        </el-button>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
      <!-- 自定义某个字段 -->
      <!-- 操作插槽 -->
      <template #guizexiangqing="scope">
        <div style="display:flex">
          <p v-for="(detail, i) in scope.row.labelRuleDetailsVOList"><span v-if="i != 0">+</span>{{ $t(store.state.dictJsonAll['BAR_CODE_RULE_TYPE'][detail.ruleType]) }}</p>
        </div>
      </template>
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button
              type="text"
              v-if="utils.checkPower('web_process_distribution_config_craft_send_batchInsert')"
              @click="
                yt.showEditDialog('bianji', scope.row, 'w1');
                setDefaultValue2(scope.row);
                getProcedureCode();
              "
            >
              {{ $t('bianji') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" class="font-color-danger"  v-if="utils.checkPower('web_process_distribution_config_craft_send_delete')"
                       @click="yt.remove(scope.row, '/custom/config/craft/send/delete')">
              {{ $t('shanchu') }}
            </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增表单 -->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('shebeimingcheng')" required>
						<yi_cross_select multiple :component="'web_base_equipment_list'"
							:ids.sync="yt.editObj.equipmentId">
						</yi_cross_select>
					</el-form-item>
          <el-form-item :label="$t('tanchuangguize')" required>
            <yi_dictionary_select clearable="false" :type="'POPUP_RULES'" :ids.sync="yt.editObj.rule" style="width: 80%;"> </yi_dictionary_select>
              <el-popover
                placement="right"
                width="600"
                trigger="hover">
                <p>{{ $t('popup_rules_info1')}}</p>
                <p>{{ $t('popup_rules_info2')}}</p>
                <p>{{ $t('popup_rules_info3')}}</p>
                <el-button slot="reference"><i class="el-icon-question"></i></el-button>
             </el-popover>

          </el-form-item>
          <el-form-item v-if="yt.editObj.rule == '2'" :label="$t('guidingshijian')" required>
            <el-input v-model="yt.editObj.times"></el-input>
          </el-form-item>
          
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST', '/custom/config/craft/send/batchInsert')" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
       <!-- 更新表单 -->
      <template v-if="yt.editObj.action == 'bianji'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('shebeimingcheng')">
						<yi_cross_select multiple :component="'web_base_equipment_list'"
							:ids.sync="yt.editObj.equipmentId" disabled>
						</yi_cross_select>
					</el-form-item>
          <el-form-item :label="$t('tanchuangguize')" required>
            <!-- <el-tooltip class="item" effect="dark" :content="$t('popup_rules_info')" placement="right">
              <yi_dictionary_select :max="1" clearable="false" :type="'POPUP_RULES'" :ids.sync="yt.editObj.rule"> </yi_dictionary_select>
          </el-tooltip> -->
          <yi_dictionary_select clearable="false" :type="'POPUP_RULES'" :ids.sync="yt.editObj.rule" style="width: 80%;"> </yi_dictionary_select>
              <el-popover
                placement="right"
                width="600"
                trigger="hover">
                <p>{{ $t('popup_rules_info1')}}</p>
                <p>{{ $t('popup_rules_info2')}}</p>
                <p>{{ $t('popup_rules_info3')}}</p>
                <el-button slot="reference"><i class="el-icon-question"></i></el-button>
             </el-popover>
          </el-form-item>
          <el-form-item  v-if="yt.editObj.rule == '2'" :label="$t('guidingshijian')" required>
            <el-input v-model="yt.editObj.times"></el-input>
          </el-form-item>
          
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST', '/custom/config/craft/send/batchInsert',beforeUpdate)" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
    </el-dialog>
    <!-- 导入excel -->
    <import-excel :show.sync="show" />
  </div>
</template>
<script type="text/javascript">
// import importExcel from './import_excel'
export default {
  name: 'web_label_management_label_rule_list',
  components: {
    // importExcel
  },
  data() {
    return {
      moveButton: true,
      currentRow: null,
      value: '',
      labelRuleDetailsVOList: [],
      multipleSelection: [],
      show: false,
      codeAndDesc: '',
      columns: [
        {
          label: 'shebeimingchen',
          prop: 'equipment.name',
          width: 180
        },
        {
          label: 'tanchuangguize',
          prop: 'rule',
          type: 'dictionary',
          key: 'POPUP_RULES',
          width: 150
        },
        {
          label: 'guidingshijian',
          prop: 'times'
        },
        {
          label: 'chuangjianren',
          prop: 'createByObject.nickname'
        },
        {
          label: 'chuangjianshijian',
          prop: 'createTime',
          type: 'time'
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 150,
          fixed: 'right'
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.conditions = {
					orderBy: 'createTime desc',
				}
      console.log(this.yt.get(1));
      this.yt.get(1);
      this.utils.event_hub.$on('QUALITY_MANAGEMENT_METHOD_REFRESH', () => {
        this.yt.get(1);
      });
    }, 300);
  },
  methods: {
    beforeUpdate(params){
      params.equipmentId = [params.equipmentId]
      return params;
    }
  }
};
</script>
